// import * as React from "react";
// import PropTypes from "prop-types";
// import Box from "@mui/material/Box";
// import Table from "@mui/material/Table";
// import TableBody from "@mui/material/TableBody";
// import TableCell from "@mui/material/TableCell";
// import TableContainer from "@mui/material/TableContainer";
// import TextField from "@mui/material/TextField";
// import TableHead from "@mui/material/TableHead";
// import Autocomplete from "@mui/material/Autocomplete";
// import TableRow from "@mui/material/TableRow";
// import TableSortLabel from "@mui/material/TableSortLabel";
// import Toolbar from "@mui/material/Toolbar";
// import Typography from "@mui/material/Typography";
// import Paper from "@mui/material/Paper";
// import Checkbox from "@mui/material/Checkbox";
// import IconButton from "@mui/material/IconButton";
// import Tooltip from "@mui/material/Tooltip";
// import EditIcon from "@mui/icons-material/Edit";
// import Dialog from "@mui/material/Dialog";
// import DialogActions from "@mui/material/DialogActions";
// import DialogContent from "@mui/material/DialogContent";
// import DialogContentText from "@mui/material/DialogContentText";
// import DialogTitle from "@mui/material/DialogTitle";
// import Button from "../../CommonComponent/Button";
// import Backdrop from "@mui/material/Backdrop";
// import CircularProgress from "@mui/material/CircularProgress";
// import Snackbar from "@mui/material/Snackbar";
// import MuiAlert from "@mui/material/Alert";
// import ExpandLessIcon from "@mui/icons-material/ExpandLess";
// import { visuallyHidden } from "@mui/utils";
// import dayjs from "dayjs";
// import utc from "dayjs/plugin/utc";
// import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
// import { useState } from "react";
// import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
// import CancelIcon from "@mui/icons-material/Cancel";
// import useHttp from "../../../Hooks/use-http";
// import BookedRidersData from "./BookedRidersData";
// import HeaderFilter from "../../CommonComponent/HeaderFilter";
// import "../../../Components/CommonTrips/DataTable.css";
// import CommonTablePagination from "../../CommonComponent/CommonTablePagination";
// import {
//   littleBlue,
//   littleGreen,
//   littleRed,
//   littleYellow,
// } from "../../CommonComponent/DefineColors";
// import { debounce } from "lodash";
// import CancelBooking from "./CancelBooking";

// dayjs.extend(utc);

// // Constants for status codes
// const STATUS_CODES = {
//   PENDING: null,
//   STARTED_MIN: 2,
//   STARTED_MAX: 7,
//   CANCELLED: -2,
// };

// let selectedDriverEmailId = "";
// let changedDateTime = {
//   date: "",
//   time: "",
// };
// let dateTimeChangeFlag = 0;
// let routeId = "";
// let lineId = "";

// function descendingComparator(a, b, orderBy) {
//   if (b[orderBy] < a[orderBy]) {
//     return -1;
//   }
//   if (b[orderBy] > a[orderBy]) {
//     return 1;
//   }
//   return 0;
// }

// function getComparator(order, orderBy) {
//   return order === "desc"
//     ? (a, b) => descendingComparator(a, b, orderBy)
//     : (a, b) => -descendingComparator(a, b, orderBy);
// }

// function stableSort(array, comparator) {
//   const stabilizedThis = array.map((el, index) => [el, index]);
//   stabilizedThis.sort((a, b) => {
//     const order = comparator(a[0], b[0]);
//     if (order !== 0) {
//       return order;
//     }
//     return a[1] - b[1];
//   });
//   return stabilizedThis?.map((el) => el[0]);
// }

// function EnhancedTableHead(props) {
//   const {
//     onSelectAllClick,
//     order,
//     orderBy,
//     numSelected,
//     rowCount,
//     onRequestSort,
//     selectAll,
//     handleSelectAllChange,
//     selectableRowsCount,
//   } = props;
//   const createSortHandler = (property) => (event) => {
//     onRequestSort(event, property);
//   };

//   const [roleId, setRoleId] = useState(localStorage.getItem("roleId"));

//   React.useEffect(() => {
//     const handleStorageChange = () => {
//       setRoleId(localStorage.getItem("roleId"));
//     };

//     window.addEventListener("storage", handleStorageChange);

//     return () => {
//       window.removeEventListener("storage", handleStorageChange);
//     };
//   }, []);

//   const headCells = [
//     {
//       id: "selection",
//       numeric: false,
//       disablePadding: true,
//       label: "",
//       width: "1%",
//     },
//     {
//       id: "expand",
//       numeric: false,
//       disablePadding: true,
//       label: "",
//       width: "1%",
//     },
//     {
//       id: "bookingID",
//       numeric: false,
//       disablePadding: true,
//       label: "Booking Id",
//     },
//     {
//       id: "RouteName",
//       numeric: true,
//       disablePadding: false,
//       label: "Route Name",
//       width: "15%",
//     },
//     ...(roleId == "1"
//       ? [
//           {
//             id: "CorporateName",
//             numeric: true,
//             disablePadding: false,
//             label: "Corporate Name",
//           },
//         ].filter(Boolean)
//       : []),
//     {
//       id: "RouteType",
//       numeric: true,
//       disablePadding: false,
//       label: "Route Type",
//     },
//     {
//       id: "ShuttleStartTime",
//       numeric: true,
//       disablePadding: false,
//       label: "Date & Time",
//       width: "15%",
//     },
//     {
//       id: "DriverEMailID",
//       numeric: true,
//       disablePadding: false,
//       label: "Assigned Driver",
//     },
//     {
//       id: "TripStatus",
//       numeric: true,
//       disablePadding: false,
//       label: "Trip Status",
//       width: "10%",
//     },
//     {
//       id: "actions",
//       numeric: false,
//       disablePadding: true,
//       label: "Actions",
//       width: "5%",
//     },
//   ];

//   return (
//     <TableHead>
//       <TableRow>
//         {headCells.map((headCell) => (
//           <TableCell
//             key={headCell.id}
//             align={"left"}
//             padding={headCell.disablePadding ? "none" : "normal"}
//             sortDirection={orderBy === headCell.id ? order : false}
//             sx={{
//               fontWeight: "bold",
//               width: headCell.width,
//               padding: "5px 0",
//               ...(headCell.id === "selection" && { paddingRight: 0 }),
//             }}
//           >
//             {headCell.id === "selection" ? (
//               <Checkbox
//                 checked={selectAll}
//                 onChange={handleSelectAllChange}
//                 indeterminate={
//                   numSelected > 0 && numSelected < selectableRowsCount
//                 }
//                 disabled={selectableRowsCount === 0}
//               />
//             ) : headCell.id === "expand" ? null : (
//               <TableSortLabel
//                 active={orderBy === headCell.id}
//                 direction={orderBy === headCell.id ? order : "asc"}
//                 onClick={createSortHandler(headCell.id)}
//               >
//                 {headCell.label}
//                 {orderBy === headCell.id ? (
//                   <Box component="span" sx={visuallyHidden}>
//                     {order === "desc"
//                       ? "sorted descending"
//                       : "sorted ascending"}
//                   </Box>
//                 ) : null}
//               </TableSortLabel>
//             )}
//           </TableCell>
//         ))}
//       </TableRow>
//     </TableHead>
//   );
// }

// EnhancedTableHead.propTypes = {
//   numSelected: PropTypes.number.isRequired,
//   onRequestSort: PropTypes.func.isRequired,
//   onSelectAllClick: PropTypes.func.isRequired,
//   order: PropTypes.oneOf(["asc", "desc"]).isRequired,
//   orderBy: PropTypes.string.isRequired,
//   rowCount: PropTypes.number.isRequired,
//   selectAll: PropTypes.bool.isRequired,
//   handleSelectAllChange: PropTypes.func.isRequired,
//   selectableRowsCount: PropTypes.number.isRequired,
// };

// function EnhancedTableToolbar(props) {
//   const {
//     selected,
//     selectedRows,
//     filteredData,
//     setFilteredData,
//     privateDrivers,
//     selectedCorporateDetails,
//     corporateData,
//     setCorporateData,
//     setSelectedCorporateDetails,
//     startDateValue,
//     endDateValue,
//     setStartDateValue,
//     setEndDateValue,
//     setIsRefreshBookingList,
//     isCancelBookingDialogOpen,
//     setIsCancelBookingDialogOpen,
//     dataLoading,
//     handleCancelSelected,
//     // showCancelDialog,
//     // setShowCancelDialog,
//     setSelectedRows,
//   } = props;

//   return (
//     <Toolbar sx={{ minHeight: "50px" }} variant="dense">
//       {selected.length > 0 || selectedRows.length > 0 ? (
//         <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
//           <Typography variant="subtitle1">
//             {selectedRows.length > 0 ? selectedRows.length : selected.length}{" "}
//             selected
//           </Typography>
//           {selected.length > 0 ? (
//             <>
//               <Tooltip title="Edit">
//                 <IconButton>
//                   <EditIcon onClick={() => props.setIsEditIconClicked(true)} />
//                 </IconButton>
//               </Tooltip>
//               <Tooltip title="Cancel">
//                 <IconButton>
//                   <CancelIcon
//                     onClick={() => props.setIsCancelBookingDialogOpen(true)}
//                   />
//                 </IconButton>
//               </Tooltip>
//             </>
//           ) : (
//             <Button
//               variant="contained"
//               color="error"
//               size="small"
//               // onClick={handleCancelSelected}
//               onClick={() => setIsCancelBookingDialogOpen(true)}
//             >
//               Cancel Selected
//             </Button>
//           )}

//           <CancelBooking
//             open={isCancelBookingDialogOpen}
//             onClose={() => setIsCancelBookingDialogOpen(false)}
//             selectedRows={selectedRows}
//             isRefresh={setIsRefreshBookingList}
//             setSelectedRows={setSelectedRows}
//           />
//         </Box>
//       ) : (
//         <LocalizationProvider dateAdapter={AdapterDayjs}>
//           <HeaderFilter
//             enableCorporateFilter={true}
//             enableDateFilter={true}
//             enableSearchFilter={true}
//             mainData={privateDrivers}
//             selectedCorporate={selectedCorporateDetails}
//             setSelectedCorporate={setSelectedCorporateDetails}
//             corporateData={corporateData}
//             setCorporateData={setCorporateData}
//             setFilteredData={setFilteredData}
//             filteredData={filteredData}
//             startDateValue={startDateValue}
//             endDateValue={endDateValue}
//             setStartDateValue={setStartDateValue}
//             setEndDateValue={setEndDateValue}
//             setIsRefereshData={setIsRefreshBookingList}
//             data={privateDrivers}
//             searchValue={props.searchValue}
//             setSearchValue={props.setSearchValue}
//             setSearchFilteredData={setFilteredData}
//             loading={props.dataLoading}
//           />
//         </LocalizationProvider>
//       )}
//     </Toolbar>
//   );
// }

// EnhancedTableToolbar.propTypes = {
//   numSelected: PropTypes.number.isRequired,
//   selectedRows: PropTypes.array.isRequired,
//   handleCancelSelected: PropTypes.func.isRequired,
// };

// export default function EditDriver({
//   privateDrivers,
//   selectedCorporateDetails,
//   dataLoading,
//   setIsRefreshBookingList,
//   driversList,
//   setStartDateValue,
//   setEndDateValue,
//   startDateValue,
//   endDateValue,
//   setSelectedCorporateDetails,
// }) {
//   const [filteredData, setFilteredData] = useState(privateDrivers);
//   const [order, setOrder] = React.useState("asc");
//   const [orderBy, setOrderBy] = React.useState("DriverName");
//   const [selected, setSelected] = React.useState([]);
//   const [selectedRows, setSelectedRows] = React.useState([]);
//   const [selectAll, setSelectAll] = React.useState(false);
//   const [page, setPage] = React.useState(0);
//   const [rowsPerPage, setRowsPerPage] = React.useState(7);
//   const [isCancelBookingDialogOpen, setIsCancelBookingDialogOpen] =
//     useState(false);
//   const [isEditRouteBookingClicked, setIsEditRouteBookingClicked] =
//     useState(false);
//   const [isEditRouteBookingResponse, setIsEditRouteBookingResponse] =
//     useState(false);
//   const [isAddDriverClicked, setIsAddDriverClicked] = useState(false);
//   const [allDriversList, setAllDriversList] = useState([]);
//   const [isFilterIconClicked, setIsFilterIconClicked] = useState(false);
//   const [isEditIconClicked, setIsEditIconClicked] = useState(false);
//   const [expandedPanel, setExpandedPanel] = useState("");
//   const [isTimeEdited, setIsTimeEdited] = useState(false);
//   const [isConfirmCancelBookingClicked, setIsConfirmCancelBookingClicked] =
//     useState(false);
//   const [isCancelBookingResponse, setIsCancelBookingResponse] = useState(false);
//   const [corporateData, setCorporateData] = useState([]);
//   const [startedCount, setStartedCount] = useState(null);
//   const [endedCount, setEndedCount] = useState(null);
//   const [pendingCount, setPendingCount] = useState(null);
//   const [editOnBookingID, setEditOnBookingID] = useState(null);
//   const [searchValue, setSearchValue] = useState("");
//   const { isLoading, sendRequest } = useHttp();
//   // const [showCancelDialog, setShowCancelDialog] = useState(false);
//   // const [isCancelBookingDialogOpen, setIsCancelBookingDialogOpen] = useState(false);
//   // Calculate selectable rows (pending trips that can be cancelled)
//   const selectableRows =
//     filteredData?.filter((item) => item.TripStatus === STATUS_CODES.PENDING) ||
//     [];
//   const selectableRowsCount = selectableRows.length;
//   const allSelectableRowsSelected =
//     selectableRowsCount > 0 && selectedRows.length === selectableRowsCount;

//   const handleRowCheckboxChange = React.useCallback((item) => {
//     setSelectedRows((prev) => {
//       const newSet = new Set(prev);
//       if (newSet.has(item.bookingID)) {
//         newSet.delete(item.bookingID);
//       } else {
//         newSet.add(item.bookingID);
//       }
//       return Array.from(newSet);
//     });
//   }, []);

//   const handleSelectAllChange = () => {
//     if (selectAll) {
//       setSelectedRows([]);
//     } else {
//       const allIds = selectableRows.map((item) => item.bookingID) || [];
//       setSelectedRows(allIds);
//     }
//     setSelectAll(!selectAll);
//   };

//   const handleCancelSelected = () => {
//     setIsCancelBookingDialogOpen(true);
//     // setShowCancelDialog(true);
//   };

//   const editRouteBookingResponse = (data) => {
//     if (data.status == 200 || data.status == 201) {
//       setIsRefreshBookingList(true);
//       setIsEditRouteBookingResponse({
//         status: "success",
//         message: "Booking Edited Successfully",
//       });
//       selectedDriverEmailId = "";
//       setSelected([]);
//       setSelectedRows([]);
//       setEditOnBookingID(null);
//     } else {
//       setIsEditRouteBookingResponse({
//         status: "error",
//         message: data.SystemMessage,
//       });
//     }
//     setIsEditRouteBookingClicked(false);
//   };

//   const driverListDetails = (data) => {
//     if (data?.DriverList) {
//       setAllDriversList(data.DriverList);
//     }
//   };

//   const bookingCancelBookingResponse = (data) => {
//     if (data.Message.toLowerCase() === "success") {
//       setIsRefreshBookingList(true);
//       setIsCancelBookingResponse({
//         status: "success",
//         message:
//           selectedRows.length > 0
//             ? "Selected bookings cancelled successfully"
//             : "Booking Cancelled Successfully",
//       });
//       selectedDriverEmailId = "";
//       setSelected([]);
//       setSelectedRows([]);
//     } else {
//       setIsCancelBookingResponse({
//         status: "error",
//         message: data.SystemMessage,
//       });
//     }
//     setIsConfirmCancelBookingClicked(false);
//   };

//   const bookingTimeChangeHandler = (
//     val,
//     currentRouteId,
//     currentlineId,
//     bookingID
//   ) => {
//     dateTimeChangeFlag = 2;
//     selectedDriverEmailId = "";
//     changedDateTime = {};
//     changedDateTime.date = `${val.$d.getFullYear()}/${
//       val.$d.getMonth() + 1
//     }/${val.$d.getDate()}`;
//     changedDateTime.time = `${val.$d.getHours()}:${val.$d.getMinutes()}:${val.$d.getSeconds()}`;
//     routeId = currentRouteId;
//     lineId = currentlineId;
//     setEditOnBookingID(bookingID);
//     setIsTimeEdited(true);
//   };

//   React.useEffect(() => {
//     let editbookings = "";
//     if (selectedDriverEmailId) {
//       if (selected.length > 0) {
//         editbookings = selected?.reduce((acc, cur) => {
//           acc.push({
//             RouteID: cur.split(" ")[0],
//             LineID: cur.split(" ")[1],
//             DriverEmailID: selectedDriverEmailId,
//             ShuttleTime: "",
//           });
//           return acc;
//         }, []);
//       } else {
//         editbookings = [
//           {
//             RouteID: routeId,
//             LineID: lineId,
//             bookingID: editOnBookingID,
//             DriverEmailID: selectedDriverEmailId,
//             ShuttleTime: "",
//           },
//         ];
//       }
//     } else {
//       editbookings = [
//         {
//           RouteID: routeId,
//           LineID: lineId,
//           bookingID: editOnBookingID,
//           DriverEmailID: "",
//           ShuttleTime: changedDateTime.date + " " + changedDateTime.time,
//         },
//       ];
//     }
//     if (isEditRouteBookingClicked) {
//       sendRequest(
//         {
//           url: "/editroutebooking",
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//           },
//           body: {
//             emailID: localStorage.getItem("user"),
//             bookingID: editOnBookingID,
//             editbookings: JSON.stringify(editbookings),
//           },
//         },
//         editRouteBookingResponse
//       );
//     }
//   }, [sendRequest, isEditRouteBookingClicked]);

//   const handleRequestSort = (event, property) => {
//     const isAsc = orderBy === property && order === "asc";
//     setOrder(isAsc ? "desc" : "asc");
//     setOrderBy(property);
//   };

//   const handleSelectAllClick = (event) => {
//     if (event.target.checked) {
//       const newSelected = filteredData?.map((n) => n.DriverEmailID);
//       setSelected(newSelected);
//       return;
//     }
//     setSelected([]);
//   };

//   const Alert = React.forwardRef(function Alert(props, ref) {
//     return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
//   });

//   const handleClick = (event, name) => {
//     const selectedIndex = selected.indexOf(name);
//     let newSelected = [];

//     if (selectedIndex === -1) {
//       newSelected = newSelected.concat(selected, name);
//     } else if (selectedIndex === 0) {
//       newSelected = newSelected.concat(selected.slice(1));
//     } else if (selectedIndex === selected.length - 1) {
//       newSelected = newSelected.concat(selected.slice(0, -1));
//     } else if (selectedIndex > 0) {
//       newSelected = newSelected.concat(
//         selected.slice(0, selectedIndex),
//         selected.slice(selectedIndex + 1)
//       );
//     }

//     setSelected(newSelected);
//   };

//   const handleChangePage = (event, newPage) => {
//     setPage(newPage);
//   };

//   const handleChangeRowsPerPage = (event) => {
//     setRowsPerPage(parseInt(event.target.value, 10));
//     setPage(0);
//   };

//   const isSelected = (name) => selected.indexOf(name) !== -1;

//   const emptyRows =
//     page > 0 ? Math.max(0, (1 + page) * rowsPerPage - filteredData?.length) : 0;

//   const visibleRows = React.useMemo(
//     () =>
//       stableSort(filteredData, getComparator(order, orderBy)).slice(
//         page * rowsPerPage,
//         page * rowsPerPage + rowsPerPage
//       ),
//     [order, orderBy, page, rowsPerPage, filteredData]
//   );

//   const tripCounts = filteredData?.reduce(
//     (acc, trip) => {
//       if (
//         trip?.TripStatus >= STATUS_CODES.STARTED_MIN &&
//         trip?.TripStatus <= STATUS_CODES.STARTED_MAX
//       ) {
//         acc.started += 1;
//       } else if (trip?.TripStatus === STATUS_CODES.CANCELLED) {
//         acc.cancelled += 1;
//       } else if (trip?.TripStatus === STATUS_CODES.PENDING) {
//         acc.pending += 1;
//       }
//       return acc;
//     },
//     { started: 0, cancelled: 0, pending: 0 }
//   );

//   React.useEffect(() => {
//     setStartedCount(tripCounts.started);
//     setPendingCount(tripCounts.pending);
//     setEndedCount(tripCounts.cancelled);
//   }, [filteredData]);

//   const statusMapping = {
//     CANCEL_BY_RIDER: { text: "Rider cancelled", color: littleRed },
//     CANCEL_BY_DRIVER: { text: "Driver cancelled", color: littleRed },
//     CANCEL_BY_ADMIN: { text: "Admin cancelled", color: littleRed },
//     REJECT: { text: "Reject", color: littleRed },
//     REQUEST: { text: "Requested", color: littleBlue },
//     ACCEPT: { text: "Accepted", color: littleBlue },
//     START_PICKUP: { text: "Start Pickup", color: littleGreen },
//     END_PICKUP: { text: "End Pickup", color: littleGreen },
//     START_TRIP: { text: "Started", color: littleGreen },
//     STOP_PASS: { text: "Passed", color: littleGreen },
//     END_TRIP: { text: "Ended", color: littleRed },
//     INVOICE: { text: "Invoice", color: littleYellow },
//     RATING: { text: "Rating", color: littleYellow },
//   };

//   return (
//     <React.Fragment>
//       {(isEditRouteBookingResponse || isCancelBookingResponse) && (
//         <Snackbar
//           open={true}
//           autoHideDuration={3000}
//           anchorOrigin={{ vertical: "top", horizontal: "right" }}
//           onClose={() =>
//             isEditRouteBookingResponse
//               ? setIsEditRouteBookingResponse(false)
//               : setIsCancelBookingResponse(false)
//           }
//         >
//           <Alert
//             onClose={() =>
//               isEditRouteBookingResponse
//                 ? setIsEditRouteBookingResponse(false)
//                 : setIsCancelBookingResponse(false)
//             }
//             severity={
//               isEditRouteBookingResponse
//                 ? isEditRouteBookingResponse.status
//                 : isCancelBookingResponse.status
//             }
//             sx={{ width: "100%" }}
//           >
//             {isEditRouteBookingResponse?.status
//               ? isEditRouteBookingResponse.message
//               : isCancelBookingResponse.message}
//           </Alert>
//         </Snackbar>
//       )}
//       {isLoading && (
//         <Backdrop
//           sx={{
//             color: "rgba(34, 137, 203, 255)",
//             zIndex: (theme) => theme.zIndex.drawer + 1,
//           }}
//           open={isLoading}
//         >
//           <CircularProgress color="inherit" />
//         </Backdrop>
//       )}
//       <Dialog
//         open={isEditIconClicked}
//         aria-labelledby="alert-dialog-title"
//         aria-describedby="alert-dialog-description"
//       >
//         <DialogTitle id="alert-dialog-title">Alert</DialogTitle>
//         <DialogContent>
//           <DialogContentText id="alert-dialog-description">
//             Please select a driver that you want to add for booking
//           </DialogContentText>
//           <Autocomplete
//             id="tags-standard"
//             options={driversList}
//             getOptionLabel={(driver) =>
//               `${driver.fName} ${driver.lName}` +
//               " (" +
//               driver.vehicleModal +
//               ")"
//             }
//             onChange={(e, newValue) =>
//               (selectedDriverEmailId = newValue.emailID)
//             }
//             renderInput={(params) => (
//               <TextField
//                 {...params}
//                 variant="standard"
//                 label="Driver Name"
//                 placeholder="Search Driver"
//               />
//             )}
//           />
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setIsEditIconClicked(false)}>Cancel</Button>
//           <Button
//             onClick={() => {
//               changedDateTime = "";
//               setIsEditIconClicked(false);
//               setIsEditRouteBookingClicked(true);
//             }}
//             autoFocus
//           >
//             Save Changes
//           </Button>
//         </DialogActions>
//       </Dialog>
//       <Dialog open={isTimeEdited}>
//         <DialogTitle>Alert</DialogTitle>
//         <DialogContent>
//           <DialogContentText>
//             Are you sure you want to change the timing?
//           </DialogContentText>
//         </DialogContent>
//         <DialogActions>
//           <Button
//             onClick={() => {
//               dateTimeChangeFlag = 0;
//               setIsTimeEdited(false);
//             }}
//           >
//             Cancel
//           </Button>
//           <Button
//             onClick={() => {
//               setIsTimeEdited(false);
//               dateTimeChangeFlag = 0;
//               setIsEditRouteBookingClicked(true);
//             }}
//           >
//             Yes
//           </Button>
//         </DialogActions>
//       </Dialog>

//       <Box sx={{ width: "97%", margin: "1.5%", borderRadius: "10px" }}>
//         <Paper sx={{ width: "100%", mb: 2, borderRadius: "10px" }}>
//           <EnhancedTableToolbar
//             setIsRefreshBookingList={setIsRefreshBookingList}
//             setStartDateValue={setStartDateValue}
//             setEndDateValue={setEndDateValue}
//             startDateValue={startDateValue}
//             endDateValue={endDateValue}
//             setIsEditIconClicked={setIsEditIconClicked}
//             selected={selected}
//             selectedRows={selectedRows}
//             setIsFilterIconClicked={setIsFilterIconClicked}
//             setIsAddDriverClicked={setIsAddDriverClicked}
//             setIsCancelBookingDialogOpen={setIsCancelBookingDialogOpen}
//             isCancelBookingDialogOpen={isCancelBookingDialogOpen}
//             selectedCorporateDetails={selectedCorporateDetails}
//             setSelectedCorporateDetails={setSelectedCorporateDetails}
//             privateDrivers={privateDrivers}
//             filteredData={filteredData}
//             setFilteredData={setFilteredData}
//             corporateData={corporateData}
//             setCorporateData={setCorporateData}
//             dataLoading={dataLoading}
//             handleCancelSelected={handleCancelSelected}
//             searchValue={searchValue}
//             setSearchValue={setSearchValue}
//             setSelectedRows={setSelectedRows}
//           />
//           <TableContainer>
//             <Table
//               sx={{ minWidth: 750, fontFamily: "Montserrat" }}
//               aria-labelledby="tableTitle"
//               size={"medium"}
//             >
//               <EnhancedTableHead
//                 numSelected={selectedRows.length}
//                 order={order}
//                 orderBy={orderBy}
//                 onSelectAllClick={handleSelectAllClick}
//                 onRequestSort={handleRequestSort}
//                 rowCount={filteredData?.length}
//                 selectedCorporateDetails={selectedCorporateDetails}
//                 selectAll={allSelectableRowsSelected}
//                 handleSelectAllChange={handleSelectAllChange}
//                 selectableRowsCount={selectableRowsCount}
//               />
//               {dataLoading ? (
//                 <TableBody>
//                   <TableRow padding="none">
//                     <TableCell colSpan={8} align="center" padding="none">
//                       <CircularProgress size="2rem" />
//                     </TableCell>
//                   </TableRow>
//                 </TableBody>
//               ) : (
//                 <TableBody>
//                   {visibleRows?.map((row, index) => {
//                     const isItemSelected = isSelected(row.RouteID);
//                     const isRowSelected = selectedRows.includes(row.bookingID);
//                     const labelId = `enhanced-table-checkbox-${index}`;
//                     const tripStatus = row?.TripStatusText;
//                     const statusInfo = statusMapping[tripStatus] || {
//                       text: tripStatus,
//                       color: "gray",
//                     };

//                     return (
//                       <React.Fragment>
//                         <TableRow
//                           hover
//                           aria-checked={isItemSelected}
//                           tabIndex={-1}
//                           key={index}
//                           selected={isItemSelected || isRowSelected}
//                           sx={{ cursor: "pointer" }}
//                           onClick={() => {
//                             if (!dateTimeChangeFlag) {
//                               setExpandedPanel(
//                                 expandedPanel === row.bookingID
//                                   ? ""
//                                   : row.bookingID
//                               );
//                             }
//                           }}
//                         >
//                           <TableCell
//                             padding="checkbox"
//                             style={{
//                               visibility:
//                                 row.TripStatus !== STATUS_CODES.PENDING ||
//                                 row.BookingStatus == "-2"
//                                   ? "hidden"
//                                   : "visible",
//                             }}
//                           >
//                             <Checkbox
//                               checked={isRowSelected}
//                               onChange={(e) => {
//                                 e.stopPropagation();
//                                 handleRowCheckboxChange(row);
//                               }}
//                             />
//                           </TableCell>
//                           <TableCell padding="none">
//                             <div style={{ display: "flex" }}>
//                               <div style={{ width: "50%" }}>
//                                 {expandedPanel === row.bookingID ? (
//                                   <ExpandLessIcon />
//                                 ) : (
//                                   <ExpandMoreIcon />
//                                 )}
//                               </div>
//                               <div style={{ width: "50%" }}>
//                                 {row.tripStatusId < 4 && (
//                                   <Checkbox
//                                     onClick={(event) => {
//                                       event.stopPropagation();
//                                       handleClick(event, row.RouteID);
//                                     }}
//                                     color="primary"
//                                     sx={{ padding: "0" }}
//                                     checked={isItemSelected}
//                                     inputProps={{
//                                       "aria-labelledby": labelId,
//                                     }}
//                                   />
//                                 )}
//                               </div>
//                             </div>
//                           </TableCell>
//                           <TableCell
//                             sx={{
//                               fontFamily: "Montserrat",
//                               paddingLeft: "5px",
//                             }}
//                             id={labelId}
//                             scope="row"
//                             padding="none"
//                             align="left"
//                           >
//                             {row.bookingID}
//                           </TableCell>
//                           <TableCell
//                             sx={{
//                               fontFamily: "Montserrat",
//                               paddingLeft: "5px",
//                             }}
//                             id={labelId}
//                             scope="row"
//                             padding="none"
//                             align="left"
//                           >
//                             {`${row.RouteName}
//                             (${row.RouteID})`}
//                           </TableCell>
//                           {localStorage.getItem("roleId") == "1" && (
//                             <TableCell
//                               align="left"
//                               padding="none"
//                               sx={{
//                                 fontFamily: "Montserrat",
//                                 paddingLeft: "5px",
//                               }}
//                             >
//                               {row.CorporateName}
//                             </TableCell>
//                           )}
//                           <TableCell
//                             align="left"
//                             padding="none"
//                             sx={{
//                               fontFamily: "Montserrat",
//                               paddingLeft: "5px",
//                             }}
//                           >
//                             {row.RouteType.toLowerCase() === "picking"
//                               ? "Pickup"
//                               : "Drop"}
//                           </TableCell>
//                           <TableCell
//                             align="left"
//                             padding="none"
//                             sx={{
//                               fontFamily: "Montserrat",
//                               paddingLeft: "5px",
//                             }}
//                           >
//                             <LocalizationProvider dateAdapter={AdapterDayjs}>
//                               <DateTimePicker
//                                 slots={{ openPickerIcon: EditIcon }}
//                                 slotProps={{
//                                   textField: {
//                                     variant: "standard",
//                                     multiline: true,
//                                     readOnly: true,
//                                     InputProps: {
//                                       disableUnderline: true,
//                                       sx: {
//                                         fontSize: "0.875rem",
//                                         button: {
//                                           marginLeft: "-30px",
//                                           display:
//                                             +row?.tripStatusId >= 4 && "none",
//                                         },
//                                         svg: {
//                                           color: "rgba(248, 94, 38,0.8)",
//                                           fontSize: "22px",
//                                           display:
//                                             +row?.tripStatusId >= 4 && "none",
//                                         },
//                                       },
//                                     },
//                                   },
//                                 }}
//                                 value={dayjs.utc(row.ShuttleStartTime, true)}
//                                 onOpen={() => (dateTimeChangeFlag = 1)}
//                                 onClose={() =>
//                                   (dateTimeChangeFlag =
//                                     dateTimeChangeFlag === 2 ? 1 : 0)
//                                 }
//                                 onAccept={(val) =>
//                                   bookingTimeChangeHandler(
//                                     val,
//                                     row.RouteID,
//                                     row?.LineID,
//                                     row?.bookingID
//                                   )
//                                 }
//                               />
//                             </LocalizationProvider>
//                           </TableCell>
//                           <TableCell
//                             padding="none"
//                             align="left"
//                             sx={{
//                               fontFamily: "Montserrat",
//                               paddingLeft: "5px",
//                             }}
//                           >
//                             <div
//                               style={{
//                                 display: "flex",
//                                 alignItems: "center",
//                                 gap: "10px",
//                               }}
//                             >
//                               <div>
//                                 <span>{row.DriverName}</span>
//                                 <div>
//                                   <span
//                                     style={{ fontSize: "12px", color: "gray" }}
//                                   >
//                                     {row.Model}
//                                   </span>
//                                 </div>
//                               </div>
//                               {+row?.tripStatusId < 4 && (
//                                 <EditIcon
//                                   style={{
//                                     color: "rgba(248, 94, 38,0.8)",
//                                     fontSize: "22px",
//                                   }}
//                                   onClick={(e) => {
//                                     e.stopPropagation();
//                                     setIsEditIconClicked(true);
//                                     routeId = row.RouteID;
//                                     lineId = row.LineID;
//                                   }}
//                                 />
//                               )}
//                             </div>
//                           </TableCell>
//                           <TableCell
//                             padding="none"
//                             align="center"
//                             className="tableCellStyle"
//                           >
//                             <div
//                               style={{
//                                 color: statusInfo.color,
//                                 border: `1px solid ${statusInfo.color}`,
//                                 borderRadius: "10px",
//                                 padding: "2px 4px 4px 2px",
//                                 fontWeight: "500",
//                                 fontSize: "10px",
//                                 textAlign: "center",
//                                 textTransform: "capitalize",
//                                 width: "auto",
//                                 margin: "auto 8px",
//                               }}
//                             >
//                               {statusInfo.text}
//                             </div>
//                           </TableCell>
//                         </TableRow>
//                         {expandedPanel === row.bookingID && (
//                           <TableRow>
//                             <TableCell colSpan={9} align="center">
//                               <BookedRidersData
//                                 routeId={row.RouteID}
//                                 data={row}
//                                 lineId={row?.LineID}
//                                 tripStatusId={row?.tripStatusId}
//                                 bookingCancelBookingResponse={
//                                   bookingCancelBookingResponse
//                                 }
//                               />
//                             </TableCell>
//                           </TableRow>
//                         )}
//                       </React.Fragment>
//                     );
//                   })}
//                   {visibleRows.length === 0 && (
//                     <TableRow>
//                       <TableCell
//                         sx={{ fontFamily: "Montserrat" }}
//                         colSpan={9}
//                         align="center"
//                       >
//                         No Data Available
//                       </TableCell>
//                     </TableRow>
//                   )}
//                   {emptyRows > 0 && (
//                     <TableRow
//                       style={{
//                         height: 53 * emptyRows,
//                       }}
//                     >
//                       <TableCell colSpan={9} />
//                     </TableRow>
//                   )}
//                 </TableBody>
//               )}
//             </Table>
//           </TableContainer>

//           <Box
//             display="flex"
//             sx={{
//               paddingRight: "16px",
//               marginTop: "8px",
//               alignContent: "center",
//               alignItems: "center",
//               display: "flex",
//               justifyContent: "space-between",
//             }}
//           >
//             <Typography
//               variant="subtitle1"
//               sx={{
//                 margin: "initial",
//                 marginLeft: "2%",
//               }}
//             >
//               <strong style={{ fontSize: "0.875rem", color: "#EDBD1A" }}>
//                 Pending:
//               </strong>
//               <span style={{ fontSize: "0.8rem" }}> {pendingCount}</span>{" "}
//               <strong style={{ fontSize: "0.875rem" }}>| </strong>
//               <strong style={{ fontSize: "0.875rem", color: "green" }}>
//                 Started:
//               </strong>
//               <span style={{ fontSize: "0.8rem" }}>{startedCount}</span>{" "}
//               <strong style={{ fontSize: "0.875rem" }}>| </strong>
//               <strong style={{ fontSize: "0.8rem", color: "red" }}>
//                 Cancelled:
//               </strong>
//               <span style={{ fontSize: "0.8rem" }}>{endedCount}</span>
//             </Typography>

//             <CommonTablePagination
//               page={page}
//               rowsPerPage={rowsPerPage}
//               setRowsPerPage={setRowsPerPage}
//               setPage={setPage}
//               filteredData={filteredData}
//               styling={{ display: "flex", justifyContent: "flex-start" }}
//             />
//           </Box>
//         </Paper>
//       </Box>
//     </React.Fragment>
//   );
// }

import * as React from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TextField from "@mui/material/TextField";
import TableHead from "@mui/material/TableHead";
import Autocomplete from "@mui/material/Autocomplete";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import Checkbox from "@mui/material/Checkbox";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import EditIcon from "@mui/icons-material/Edit";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "../../CommonComponent/Button";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import { visuallyHidden } from "@mui/utils";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { useState } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CancelIcon from "@mui/icons-material/Cancel";
import useHttp from "../../../Hooks/use-http";
import BookedRidersData from "./BookedRidersData";
import HeaderFilter from "../../CommonComponent/HeaderFilter";
import "../../../Components/CommonTrips/DataTable.css";
import CommonTablePagination from "../../CommonComponent/CommonTablePagination";
import PortalTitle from "../../CommonComponent/PortalTitle";
import {
  littleBlue,
  littleGreen,
  littleRed,
  littleYellow,
} from "../../CommonComponent/DefineColors";
import { debounce } from "lodash";
import CancelBooking from "./CancelBooking";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DriveEtaIcon from "@mui/icons-material/DriveEta";
import { toast } from "react-toastify";
import { PAGINATIONBASEVALUE } from "../../../Constant";

dayjs.extend(utc);

// Constants for status codes
const STATUS_CODES = {
  PENDING: null,
  STARTED_MIN: 2,
  STARTED_MAX: 7,
  CANCELLED: -2,
};

let selectedDriverEmailId = "";
let changedDateTime = {
  date: "",
  time: "",
};
let dateTimeChangeFlag = 0;
let routeId = "";
let lineId = "";

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis?.map((el) => el[0]);
}

function EnhancedTableHead(props) {
  const {
    onSelectAllClick,
    order,
    orderBy,
    numSelected,
    rowCount,
    onRequestSort,
    selectAll,
    handleSelectAllChange,
    selectableRowsCount,
  } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  const [roleId, setRoleId] = useState(localStorage.getItem("roleId"));

  React.useEffect(() => {
    const handleStorageChange = () => {
      setRoleId(localStorage.getItem("roleId"));
    };

    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  const headCells = [
    {
      id: "selection",
      numeric: false,
      disablePadding: true,
      label: "",
      width: "1%",
    },
    {
      id: "expand",
      numeric: false,
      disablePadding: true,
      label: "",
      width: "1%",
    },
    {
      id: "bookingID",
      numeric: false,
      disablePadding: true,
      label: "Booking Id",
    },
    {
      id: "RouteName",
      numeric: true,
      disablePadding: false,
      label: "Route Name",
      width: "15%",
    },
    ...(roleId == "1"
      ? [
          {
            id: "CorporateName",
            numeric: true,
            disablePadding: false,
            label: "Corporate",
          },
        ].filter(Boolean)
      : []),
    {
      id: "RouteType",
      numeric: true,
      disablePadding: false,
      label: "Route Type",
    },
    {
      id: "ShuttleStartTime",
      numeric: true,
      disablePadding: false,
      label: "Date & Time",
      width: "15%",
    },
    {
      id: "DriverEMailID",
      numeric: true,
      disablePadding: false,
      label: "Driver",
    },
    {
      id: "TripStatus",
      numeric: true,
      disablePadding: false,
      label: "Status",
      width: "10%",
    },
    {
      id: "actions",
      numeric: false,
      disablePadding: true,
      label: "Actions",
      width: "5%",
    },
  ];

  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align="center"
            padding={headCell.disablePadding ? "none" : "normal"}
            sortDirection={orderBy === headCell.id ? order : false}
            sx={{
              fontWeight: 600,
              fontSize: "0.875rem",
              py: 1,
              px: 2,
              color: "rgba(0, 0, 0, 0.87)",
              width: headCell.width,
              ...(headCell.id === "selection" && { paddingRight: 0 }),
            }}
          >
            {headCell.id === "selection" ? (
              <Checkbox
                checked={selectAll}
                onChange={handleSelectAllChange}
                indeterminate={
                  numSelected > 0 && numSelected < selectableRowsCount
                }
                disabled={selectableRowsCount === 0}
              />
            ) : headCell.id === "expand" ? null : headCell.id === "actions" ? (
              headCell.label
            ) : (
              <TableSortLabel
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : "asc"}
                onClick={createSortHandler(headCell.id)}
              >
                {headCell.label}
                {orderBy === headCell.id ? (
                  <Box component="span" sx={visuallyHidden}>
                    {order === "desc"
                      ? "sorted descending"
                      : "sorted ascending"}
                  </Box>
                ) : null}
              </TableSortLabel>
            )}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
  selectAll: PropTypes.bool.isRequired,
  handleSelectAllChange: PropTypes.func.isRequired,
  selectableRowsCount: PropTypes.number.isRequired,
};

function EnhancedTableToolbar(props) {
  const {
    selected,
    selectedRows,
    filteredData,
    setFilteredData,
    privateDrivers,
    selectedCorporateDetails,
    corporateData,
    setCorporateData,
    setSelectedCorporateDetails,
    startDateValue,
    endDateValue,
    setStartDateValue,
    setEndDateValue,
    setIsRefreshBookingList,
    isCancelBookingDialogOpen,
    setIsCancelBookingDialogOpen,
    dataLoading,
    handleCancelSelected,
    setSelectedRows,
  } = props;

  return (
    <Toolbar
      sx={{
        minHeight: "auto",
        padding: "0 !important",
      }}
      variant="dense"
    >
      {selected.length > 0 || selectedRows.length > 0 ? (
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <Typography variant="subtitle1">
            {selectedRows.length > 0 ? selectedRows.length : selected.length}{" "}
            selected
          </Typography>
          {selected.length > 0 ? (
            <>
              <Tooltip title="Edit">
                <IconButton>
                  <EditIcon onClick={() => props.setIsEditIconClicked(true)} />
                </IconButton>
              </Tooltip>
              <Tooltip title="Cancel">
                <IconButton>
                  <CancelIcon
                    onClick={() => props.setIsCancelBookingDialogOpen(true)}
                  />
                </IconButton>
              </Tooltip>
            </>
          ) : (
            <Button
              label="Cancel Selected"
              variant="contained"
              backgroundColor="red"
              size="small"
              onClick={() => setIsCancelBookingDialogOpen(true)}
            />
          )}

          <CancelBooking
            open={isCancelBookingDialogOpen}
            onClose={() => setIsCancelBookingDialogOpen(false)}
            selectedRows={selectedRows}
            isRefresh={setIsRefreshBookingList}
            setSelectedRows={setSelectedRows}
          />
        </Box>
      ) : (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <HeaderFilter
            enableCorporateFilter={true}
            enableDateFilter={true}
            enableSearchFilter={true}
            mainData={privateDrivers}
            selectedCorporate={selectedCorporateDetails}
            setSelectedCorporate={setSelectedCorporateDetails}
            corporateData={corporateData}
            setCorporateData={setCorporateData}
            setFilteredData={setFilteredData}
            filteredData={filteredData}
            startDateValue={startDateValue}
            endDateValue={endDateValue}
            setStartDateValue={setStartDateValue}
            setEndDateValue={setEndDateValue}
            setIsRefereshData={setIsRefreshBookingList}
            data={privateDrivers}
            searchValue={props.searchValue}
            setSearchValue={props.setSearchValue}
            setSearchFilteredData={setFilteredData}
            loading={props.dataLoading}
          />
        </LocalizationProvider>
      )}
    </Toolbar>
  );
}

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
  selectedRows: PropTypes.array.isRequired,
  handleCancelSelected: PropTypes.func.isRequired,
};

export default function EditDriver({
  privateDrivers,
  selectedCorporateDetails,
  dataLoading,
  setIsRefreshBookingList,
  driversList,
  setStartDateValue,
  setEndDateValue,
  startDateValue,
  endDateValue,
  setSelectedCorporateDetails,
  setIsNewBookingClicked,
}) {
  const [filteredData, setFilteredData] = useState(privateDrivers);
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("DriverName");
  const [selected, setSelected] = React.useState([]);
  const [selectedRows, setSelectedRows] = React.useState([]);
  const [selectAll, setSelectAll] = React.useState(false);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(PAGINATIONBASEVALUE);
  const [isCancelBookingDialogOpen, setIsCancelBookingDialogOpen] =
    useState(false);
  const [isEditRouteBookingClicked, setIsEditRouteBookingClicked] =
    useState(false);
  const [isDriverChangeClicked, setIsDriverChangeClicked] = useState(false);
  const [isEditRouteBookingResponse, setIsEditRouteBookingResponse] =
    useState(false);
  const [isAddDriverClicked, setIsAddDriverClicked] = useState(false);
  const [allDriversList, setAllDriversList] = useState([]);
  const [isFilterIconClicked, setIsFilterIconClicked] = useState(false);
  const [isEditIconClicked, setIsEditIconClicked] = useState(false);
  const [expandedPanel, setExpandedPanel] = useState("");
  const [isTimeEdited, setIsTimeEdited] = useState(false);
  const [isConfirmCancelBookingClicked, setIsConfirmCancelBookingClicked] =
    useState(false);
  const [isCancelBookingResponse, setIsCancelBookingResponse] = useState(false);
  const [corporateData, setCorporateData] = useState([]);
  const [startedCount, setStartedCount] = useState(null);
  const [endedCount, setEndedCount] = useState(null);
  const [pendingCount, setPendingCount] = useState(null);
  const [editOnBookingID, setEditOnBookingID] = useState(null);
  const [searchValue, setSearchValue] = useState("");
  const { isLoading, sendRequest } = useHttp();

  // Menu state
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [selectedBooking, setSelectedBooking] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleMenuClick = (event, booking) => {
    console.log("Menu clicked for booking:", booking);
    setAnchorEl(event.currentTarget);
    setSelectedBooking(booking);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  // Calculate selectable rows (pending trips that can be cancelled)
  const selectableRows =
    filteredData?.filter((item) => item.TripStatus === STATUS_CODES.PENDING) ||
    [];
  const selectableRowsCount = selectableRows.length;
  const allSelectableRowsSelected =
    selectableRowsCount > 0 && selectedRows.length === selectableRowsCount;

  const handleRowCheckboxChange = React.useCallback((item) => {
    setSelectedRows((prev) => {
      const newSet = new Set(prev);
      if (newSet.has(item.bookingID)) {
        newSet.delete(item.bookingID);
      } else {
        newSet.add(item.bookingID);
      }
      return Array.from(newSet);
    });
  }, []);

  const handleSelectAllChange = () => {
    if (selectAll) {
      setSelectedRows([]);
    } else {
      const allIds = selectableRows.map((item) => item.bookingID) || [];
      setSelectedRows(allIds);
    }
    setSelectAll(!selectAll);
  };

  const handleCancelSelected = () => {
    setIsCancelBookingDialogOpen(true);
  };

  const editRouteBookingResponse = (data) => {
    if (data.status == 200 || data.status == 201) {
      setIsRefreshBookingList(true);
      setIsEditRouteBookingResponse({
        status: "success",
        message: "Booking Edited Successfully",
      });
      selectedDriverEmailId = "";
      setSelected([]);
      setSelectedRows([]);
      setEditOnBookingID(null);
    } else {
      setIsEditRouteBookingResponse({
        status: "error",
        message: data.SystemMessage,
      });
    }
    setIsEditRouteBookingClicked(false);
  };

  const driverListDetails = (data) => {
    if (data?.DriverList) {
      setAllDriversList(data.DriverList);
    }
  };

  const bookingCancelBookingResponse = (data) => {
    if (data.Message.toLowerCase() === "success") {
      setIsRefreshBookingList(true);
      setIsCancelBookingResponse({
        status: "success",
        message:
          selectedRows.length > 0
            ? "Selected bookings cancelled successfully"
            : "Booking Cancelled Successfully",
      });
      selectedDriverEmailId = "";
      setSelected([]);
      setSelectedRows([]);
    } else {
      setIsCancelBookingResponse({
        status: "error",
        message: data.SystemMessage,
      });
    }
    setIsConfirmCancelBookingClicked(false);
  };

  const bookingTimeChangeHandler = (
    val,
    currentRouteId,
    currentlineId,
    bookingID
  ) => {
    dateTimeChangeFlag = 2;
    selectedDriverEmailId = "";
    changedDateTime = {};
    changedDateTime.date = `${val.$d.getFullYear()}/${
      val.$d.getMonth() + 1
    }/${val.$d.getDate()}`;
    changedDateTime.time = `${val.$d.getHours()}:${val.$d.getMinutes()}:${val.$d.getSeconds()}`;
    routeId = currentRouteId;
    lineId = currentlineId;
    setEditOnBookingID(bookingID);
    setIsTimeEdited(true);
  };

  React.useEffect(() => {
    let editbookings = "";
    if (selectedDriverEmailId) {
      if (selected.length > 0) {
        editbookings = selected?.reduce((acc, cur) => {
          acc.push({
            RouteID: cur.split(" ")[0],
            LineID: cur.split(" ")[1],
            DriverEmailID: selectedDriverEmailId,
            ShuttleTime: "",
          });
          return acc;
        }, []);
      } else {
        editbookings = [
          {
            RouteID: routeId,
            LineID: lineId,
            bookingID: editOnBookingID,
            DriverEmailID: selectedDriverEmailId,
            ShuttleTime: "",
          },
        ];
      }
    } else {
      editbookings = [
        {
          RouteID: routeId,
          LineID: lineId,
          bookingID: editOnBookingID,
          DriverEmailID: "",
          ShuttleTime: changedDateTime.date + " " + changedDateTime.time,
        },
      ];
    }
    if (isEditRouteBookingClicked) {
      sendRequest(
        {
          url: "/editroutebooking",
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: {
            emailID: localStorage.getItem("user"),
            bookingID: editOnBookingID,
            editbookings: JSON.stringify(editbookings),
          },
        },
        editRouteBookingResponse
      );
    }
  }, [sendRequest, isEditRouteBookingClicked]);

  React.useEffect(() => {
    if (!isDriverChangeClicked) return;
    sendRequest(
      {
        url: "/changeDriverInShuttleBooking",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: {
          emailID: localStorage.getItem("user"),
          data: {
            bookingID: selectedBooking?.bookingID,
            driverEmailID: selectedDriverEmailId,
          },
        },
      },
      handleDriverChangeResponse
    );
  }, [sendRequest, isDriverChangeClicked]);

  const handleDriverChangeResponse = (data) => {
    try {
      if (data.status == "200" || data.status == "201") {
        setIsRefreshBookingList(true);
        toast.success(data.statusMessage || "Driver changed successfully");

        // setIsRefreshBookingList((prev) => !prev);
        setIsDriverChangeClicked(false);
        setSelected([]);
        setSelectedRows([]);
        selectedDriverEmailId = "";
        setIsEditIconClicked(false);
        setIsTimeEdited(false);
        setEditOnBookingID(null);
      } else {
        toast.error(data.statusMessage || "Failed to change driver");

        setIsDriverChangeClicked(false);
        setIsEditIconClicked(false);
        setIsTimeEdited(false);
        setEditOnBookingID(null);
      }
    } catch (error) {
      setIsDriverChangeClicked(false);
      setIsEditIconClicked(false);
      setIsTimeEdited(false);
      setEditOnBookingID(null);
      toast.error(data.statusMessage || "Failed to change driver");
    }
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelected = filteredData?.map((n) => n.DriverEmailID);
      setSelected(newSelected);
      return;
    }
    setSelected([]);
  };

  const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const isSelected = (name) => selected.indexOf(name) !== -1;

  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - filteredData?.length) : 0;

  const visibleRows = React.useMemo(
    () =>
      stableSort(filteredData, getComparator(order, orderBy)).slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage
      ),
    [order, orderBy, page, rowsPerPage, filteredData]
  );

  const tripCounts = filteredData?.reduce(
    (acc, trip) => {
      if (
        trip?.TripStatus >= STATUS_CODES.STARTED_MIN &&
        trip?.TripStatus <= STATUS_CODES.STARTED_MAX
      ) {
        acc.started += 1;
      } else if (trip?.TripStatus === STATUS_CODES.CANCELLED) {
        acc.cancelled += 1;
      } else if (trip?.TripStatus === STATUS_CODES.PENDING) {
        acc.pending += 1;
      }
      return acc;
    },
    { started: 0, cancelled: 0, pending: 0 }
  );

  React.useEffect(() => {
    setStartedCount(tripCounts.started);
    setPendingCount(tripCounts.pending);
    setEndedCount(tripCounts.cancelled);
  }, [filteredData]);

  const statusMapping = {
    CANCEL_BY_RIDER: { text: "Rider cancelled", color: littleRed },
    CANCEL_BY_DRIVER: { text: "Driver cancelled", color: littleRed },
    CANCEL_BY_ADMIN: { text: "Admin cancelled", color: littleRed },
    REJECT: { text: "Reject", color: littleRed },
    REQUEST: { text: "Requested", color: littleBlue },
    ACCEPT: { text: "Accepted", color: littleBlue },
    START_PICKUP: { text: "Start Pickup", color: littleGreen },
    END_PICKUP: { text: "End Pickup", color: littleGreen },
    START_TRIP: { text: "Started", color: littleGreen },
    STOP_PASS: { text: "Passed", color: littleGreen },
    END_TRIP: { text: "Ended", color: littleRed },
    INVOICE: { text: "Invoice", color: littleYellow },
    RATING: { text: "Rating", color: littleYellow },
  };

  return (
    <React.Fragment>
      {(isEditRouteBookingResponse || isCancelBookingResponse) && (
        <Snackbar
          open={true}
          autoHideDuration={3000}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          onClose={() =>
            isEditRouteBookingResponse
              ? setIsEditRouteBookingResponse(false)
              : setIsCancelBookingResponse(false)
          }
        >
          <Alert
            onClose={() =>
              isEditRouteBookingResponse
                ? setIsEditRouteBookingResponse(false)
                : setIsCancelBookingResponse(false)
            }
            severity={
              isEditRouteBookingResponse
                ? isEditRouteBookingResponse.status
                : isCancelBookingResponse.status
            }
            sx={{ width: "100%" }}
          >
            {isEditRouteBookingResponse?.status
              ? isEditRouteBookingResponse.message
              : isCancelBookingResponse.message}
          </Alert>
        </Snackbar>
      )}
      {isLoading && (
        <Backdrop
          sx={{
            color: "rgba(34, 137, 203, 255)",
            zIndex: (theme) => theme.zIndex.drawer + 1,
          }}
          open={isLoading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
      <Dialog
        open={isEditIconClicked}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Alert</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Please select a driver that you want to add for booking
          </DialogContentText>
          <Autocomplete
            id="tags-standard"
            options={driversList}
            getOptionLabel={(driver) =>
              `${driver.driverName}` + " (" + driver.driverCarModel + ")"
            }
            onChange={(e, newValue) =>
              (selectedDriverEmailId = newValue.driverEmailId)
            }
            renderInput={(params) => (
              <TextField
                {...params}
                variant="standard"
                label="Driver Name"
                placeholder="Search Driver"
              />
            )}
          />
        </DialogContent>
        <DialogActions>
          <Button
            label="Cancel"
            variant="contained"
            backgroundColor="red"
            size="small"
            onClick={() => setIsEditIconClicked(false)}
          />
          <Button
            label="Save Changes"
            variant="contained"
            backgroundColor="green"
            size="small"
            onClick={() => {
              changedDateTime = "";
              setIsEditIconClicked(false);
              setIsDriverChangeClicked(true);
            }}
            autoFocus
          />
        </DialogActions>
      </Dialog>
      <Dialog open={isTimeEdited}>
        <DialogTitle>Alert</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to change the timing?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            label="Cancel"
            size="small"
            onClick={() => {
              dateTimeChangeFlag = 0;
              setIsTimeEdited(false);
            }}
          />
          <Button
            label="Yes"
            size="small"
            onClick={() => {
              setIsTimeEdited(false);
              dateTimeChangeFlag = 0;
              setIsEditRouteBookingClicked(true);
            }}
          />
        </DialogActions>
      </Dialog>

      {/* Menu for Actions */}
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleMenuClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        <MenuItem
          onClick={() => {
            setIsEditIconClicked(true);
            routeId = selectedBooking.RouteID;
            lineId = selectedBooking.LineID;
            handleMenuClose();
          }}
        >
          <ListItemIcon>
            <DriveEtaIcon fontSize="small" />
          </ListItemIcon>
          Change Driver
        </MenuItem>
        <MenuItem
          onClick={() => {
            setExpandedPanel(
              expandedPanel === selectedBooking.bookingID
                ? ""
                : selectedBooking.bookingID
            );
            handleMenuClose();
          }}
        >
          <ListItemIcon>
            <VisibilityIcon fontSize="small" />
          </ListItemIcon>
          View
        </MenuItem>
      </Menu>

      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Paper
          sx={{
            width: "100%",
            mb: 2,
            borderRadius: "10px",
            flex: 1,
            display: "flex",
            flexDirection: "column",
            border: "none",
            borderBottom: "none",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              px: 2,
              pt: 1,
              pb: 1,
              borderRadius: "10px",
              flexDirection: { xs: "column", md: "row" },
              gap: { xs: 1, md: 0 },
            }}
          >
            <Box component="h2" sx={{ m: 0, display: "flex", alignItems: "center", minWidth: 0, flexShrink: 0 }}>
              <PortalTitle fallback="Shuttle Bookings" />
            </Box>
            <Box
              sx={{
                display: "flex",
                gap: "12px",
                alignItems: "center",
                flexDirection: { xs: "column", md: "row" },
          }}
        >
          <EnhancedTableToolbar
            setIsRefreshBookingList={setIsRefreshBookingList}
            setStartDateValue={setStartDateValue}
            setEndDateValue={setEndDateValue}
            startDateValue={startDateValue}
            endDateValue={endDateValue}
            setIsEditIconClicked={setIsEditIconClicked}
            selected={selected}
            selectedRows={selectedRows}
            setIsFilterIconClicked={setIsFilterIconClicked}
            setIsAddDriverClicked={setIsAddDriverClicked}
            setIsCancelBookingDialogOpen={setIsCancelBookingDialogOpen}
            isCancelBookingDialogOpen={isCancelBookingDialogOpen}
            selectedCorporateDetails={selectedCorporateDetails}
            setSelectedCorporateDetails={setSelectedCorporateDetails}
            privateDrivers={privateDrivers}
            filteredData={filteredData}
            setFilteredData={setFilteredData}
            corporateData={corporateData}
            setCorporateData={setCorporateData}
            dataLoading={dataLoading}
            handleCancelSelected={handleCancelSelected}
            searchValue={searchValue}
            setSearchValue={setSearchValue}
            setSelectedRows={setSelectedRows}
          />
          {setIsNewBookingClicked && (
            <Button
              label="Add New Booking"
              onClick={() => setIsNewBookingClicked(true)}
              variant="contained"
              size="medium"
              sx={{
                backgroundColor: "#44B150",
                ":hover": {
                  backgroundColor: "#44B150",
                  opacity: 0.8,
                },
                boxShadow: "none",
                fontFamily: "Montserrat",
                fontSize: "12px",
                padding: "8px 20px",
                textTransform: "none",
                minWidth: "auto",
              }}
            />
          )}
            </Box>
          </Box>
          <TableContainer
            component={Paper}
            sx={{
              borderRadius: "10px",
              boxShadow: "none",
              border: "none",
              borderBottom: "none",
              "& .MuiPaper-root": {
                border: "none",
                borderBottom: "none",
              },
            }}
          >
            <Table
              sx={{
                minWidth: 750,
                fontFamily: "Montserrat",
              }}
              aria-labelledby="tableTitle"
              size="medium"
            >
              <EnhancedTableHead
                numSelected={selectedRows.length}
                order={order}
                orderBy={orderBy}
                onSelectAllClick={handleSelectAllClick}
                onRequestSort={handleRequestSort}
                rowCount={filteredData?.length}
                selectedCorporateDetails={selectedCorporateDetails}
                selectAll={allSelectableRowsSelected}
                handleSelectAllChange={handleSelectAllChange}
                selectableRowsCount={selectableRowsCount}
              />
              {dataLoading ? (
                <TableBody>
                  <TableRow padding="none">
                    <TableCell colSpan={10} align="center" padding="none">
                      <CircularProgress size="2rem" />
                    </TableCell>
                  </TableRow>
                </TableBody>
              ) : (
                <TableBody>
                  {visibleRows?.map((row, index) => {
                    const isItemSelected = isSelected(row.RouteID);
                    const isRowSelected = selectedRows.includes(row.bookingID);
                    const labelId = `enhanced-table-checkbox-${index}`;
                    const tripStatus = row?.TripStatusText;
                    const statusInfo = statusMapping[tripStatus] || {
                      text: tripStatus,
                      color: "gray",
                    };

                    return (
                      <React.Fragment>
                        <TableRow
                          hover
                          aria-checked={isItemSelected}
                          tabIndex={-1}
                          key={index}
                          selected={isItemSelected || isRowSelected}
                          sx={{ cursor: "pointer" }}
                          onClick={() => {
                            if (!dateTimeChangeFlag) {
                              setExpandedPanel(
                                expandedPanel === row.bookingID
                                  ? ""
                                  : row.bookingID
                              );
                            }
                          }}
                        >
                          <TableCell
                            padding="checkbox"
                            style={{
                              visibility:
                                row.TripStatus !== STATUS_CODES.PENDING ||
                                row.BookingStatus == "-2"
                                  ? "hidden"
                                  : "visible",
                            }}
                          >
                            <Checkbox
                              checked={isRowSelected}
                              onChange={(e) => {
                                e.stopPropagation();
                                handleRowCheckboxChange(row);
                              }}
                            />
                          </TableCell>
                          <TableCell padding="none">
                            <div style={{ display: "flex" }}>
                              <div style={{ width: "50%" }}>
                                {expandedPanel === row.bookingID ? (
                                  <ExpandLessIcon />
                                ) : (
                                  <ExpandMoreIcon />
                                )}
                              </div>
                              <div style={{ width: "50%" }}>
                                {row.tripStatusId < 4 && (
                                  <Checkbox
                                    onClick={(event) => {
                                      event.stopPropagation();
                                      handleClick(event, row.RouteID);
                                    }}
                                    color="primary"
                                    sx={{ padding: "0" }}
                                    checked={isItemSelected}
                                    inputProps={{
                                      "aria-labelledby": labelId,
                                    }}
                                  />
                                )}
                              </div>
                            </div>
                          </TableCell>
                          <TableCell
                            align="center"
                            sx={{
                              fontFamily: "Montserrat",
                              fontSize: "0.875rem",
                              py: 1,
                              px: 2,
                            }}
                            id={labelId}
                            scope="row"
                            padding="none"
                          >
                            {row.bookingID}
                          </TableCell>
                          <TableCell
                            align="center"
                            sx={{
                              fontFamily: "Montserrat",
                              fontSize: "0.875rem",
                              py: 1,
                              px: 2,
                            }}
                            id={labelId}
                            scope="row"
                            padding="none"
                          >
                            {`${row.RouteName} 
                            (${row.RouteID})`}
                          </TableCell>
                          {localStorage.getItem("roleId") == "1" && (
                            <TableCell
                              align="center"
                              padding="none"
                              sx={{
                                fontFamily: "Montserrat",
                                fontSize: "0.875rem",
                                py: 1,
                                px: 2,
                              }}
                            >
                              {row.CorporateName}
                            </TableCell>
                          )}
                          <TableCell
                            align="center"
                            padding="none"
                            sx={{
                              fontFamily: "Montserrat",
                              fontSize: "0.875rem",
                              py: 1,
                              px: 2,
                            }}
                          >
                            {row.RouteType.toLowerCase() === "picking"
                              ? "Pickup"
                              : "Drop"}
                          </TableCell>
                          <TableCell
                            align="center"
                            padding="none"
                            sx={{
                              fontFamily: "Montserrat",
                              fontSize: "0.875rem",
                              py: 1,
                              px: 2,
                            }}
                          >
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <DateTimePicker
                                slots={{ openPickerIcon: EditIcon }}
                                slotProps={{
                                  textField: {
                                    variant: "standard",
                                    multiline: true,
                                    readOnly: true,
                                    InputProps: {
                                      disableUnderline: true,
                                      sx: {
                                        fontSize: "0.875rem",
                                        button: {
                                          marginLeft: "-30px",
                                          display:
                                            +row?.tripStatusId >= 4 && "none",
                                        },
                                        svg: {
                                          color: "rgba(248, 94, 38,0.8)",
                                          fontSize: "22px",
                                          display:
                                            +row?.tripStatusId >= 4 && "none",
                                        },
                                      },
                                    },
                                  },
                                }}
                                value={dayjs.utc(row.ShuttleStartTime, true)}
                                onOpen={() => (dateTimeChangeFlag = 1)}
                                onClose={() =>
                                  (dateTimeChangeFlag =
                                    dateTimeChangeFlag === 2 ? 1 : 0)
                                }
                                onAccept={(val) =>
                                  bookingTimeChangeHandler(
                                    val,
                                    row.RouteID,
                                    row?.LineID,
                                    row?.bookingID
                                  )
                                }
                              />
                            </LocalizationProvider>
                          </TableCell>
                          <TableCell
                            align="center"
                            padding="none"
                            sx={{
                              fontFamily: "Montserrat",
                              fontSize: "0.875rem",
                              py: 1,
                              px: 2,
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "10px",
                              }}
                            >
                              <div>
                                <span>{row.DriverName}</span>
                                <div>
                                  <span
                                    style={{ fontSize: "12px", color: "gray" }}
                                  >
                                    {row.Model}
                                  </span>
                                </div>
                              </div>
                              {+row?.tripStatusId < 4 && (
                                <EditIcon
                                  style={{
                                    color: "rgba(248, 94, 38,0.8)",
                                    fontSize: "22px",
                                  }}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setIsEditIconClicked(true);
                                    routeId = row.RouteID;
                                    lineId = row.LineID;
                                  }}
                                />
                              )}
                            </div>
                          </TableCell>
                          <TableCell
                            align="center"
                            padding="none"
                            sx={{
                              fontFamily: "Montserrat",
                              fontSize: "0.875rem",
                              py: 1,
                              px: 2,
                            }}
                          >
                            <div
                              style={{
                                color: statusInfo.color,
                                border: `1px solid ${statusInfo.color}`,
                                borderRadius: "10px",
                                padding: "2px 4px 4px 2px",
                                fontWeight: "500",
                                fontSize: "10px",
                                textAlign: "center",
                                textTransform: "capitalize",
                                width: "auto",
                                margin: "auto 8px",
                              }}
                            >
                              {statusInfo.text}
                            </div>
                          </TableCell>
                          <TableCell
                            align="center"
                            padding="none"
                            sx={{
                              fontFamily: "Montserrat",
                              fontSize: "0.875rem",
                              py: 1,
                              px: 2,
                            }}
                          >
                            <IconButton
                              aria-label="more"
                              aria-controls="long-menu"
                              aria-haspopup="true"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleMenuClick(e, row);
                              }}
                            >
                              <MoreVertIcon />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                        {expandedPanel === row.bookingID && (
                          <TableRow>
                            <TableCell colSpan={10} align="center">
                              <BookedRidersData
                                routeId={row.RouteID}
                                data={row}
                                lineId={row?.LineID}
                                tripStatusId={row?.tripStatusId}
                                bookingCancelBookingResponse={
                                  bookingCancelBookingResponse
                                }
                              />
                            </TableCell>
                          </TableRow>
                        )}
                      </React.Fragment>
                    );
                  })}
                  {visibleRows.length === 0 && (
                    <TableRow>
                      <TableCell
                        sx={{ fontFamily: "Montserrat" }}
                        colSpan={10}
                        align="center"
                      >
                        No Data Available
                      </TableCell>
                    </TableRow>
                  )}
                  {emptyRows > 0 && (
                    <TableRow
                      style={{
                        height: 53 * emptyRows,
                      }}
                    >
                      <TableCell colSpan={10} />
                    </TableRow>
                  )}
                </TableBody>
              )}
            </Table>
          </TableContainer>
          <Box
            sx={{
              position: "sticky",
              bottom: 0,
              background: "white",
              zIndex: 1,
              border: "none !important",
              borderTop: "none !important",
              borderBottom: "none !important",
              "&::before": {
                display: "none",
              },
              "&::after": {
                display: "none",
              },
            }}
          >
            <Box
              display="flex"
              sx={{
                paddingRight: "16px",
                marginTop: "8px",
                alignContent: "center",
                alignItems: "center",
                display: "flex",
                justifyContent: "space-between",
                border: "none !important",
                borderTop: "none !important",
                borderBottom: "none !important",
                "&::before": {
                  display: "none",
                },
                "&::after": {
                  display: "none",
                },
              }}
            >
              <Typography
                variant="subtitle1"
                sx={{
                  margin: "initial",
                  marginLeft: "2%",
                }}
              >
                <strong style={{ fontSize: "0.875rem", color: "#EDBD1A" }}>
                  Pending:
                </strong>
                <span style={{ fontSize: "0.8rem" }}> {pendingCount}</span>{" "}
                <strong style={{ fontSize: "0.875rem" }}>| </strong>
                <strong style={{ fontSize: "0.875rem", color: "green" }}>
                  Started:
                </strong>
                <span style={{ fontSize: "0.8rem" }}>{startedCount}</span>{" "}
                <strong style={{ fontSize: "0.875rem" }}>| </strong>
                <strong style={{ fontSize: "0.8rem", color: "red" }}>
                  Cancelled:
                </strong>
                <span style={{ fontSize: "0.8rem" }}>{endedCount}</span>
              </Typography>

              <CommonTablePagination
                page={page}
                rowsPerPage={rowsPerPage}
                setRowsPerPage={setRowsPerPage}
                setPage={setPage}
                filteredData={filteredData}
                styling={{
                  display: "flex",
                  justifyContent: "flex-start",
                  border: "none",
                  borderTop: "none",
                  borderBottom: "none",
                  "& .MuiTablePagination-root": {
                    border: "none",
                    borderTop: "none",
                    borderBottom: "none",
                    "&::before": {
                      display: "none",
                    },
                    "&::after": {
                      display: "none",
                    },
                  },
                  "& .MuiTablePagination-toolbar": {
                    border: "none",
                    borderTop: "none",
                    borderBottom: "none",
                    "&::before": {
                      display: "none",
                    },
                    "&::after": {
                      display: "none",
                    },
                  },
                  "& .MuiTablePagination-spacer": {
                    border: "none",
                  },
                }}
              />
            </Box>
          </Box>
        </Paper>
      </Box>
    </React.Fragment>
  );
}
